import script from "./receivingAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./receivingAddress.vue?vue&type=script&setup=true&lang=js"

import "./receivingAddress.vue?vue&type=style&index=0&id=5c5cc96a&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5cc96a"]])

export default __exports__